import { FormattedMessage } from "react-intl";

import {
  SelectContent,
  SelectField,
  SelectItem,
} from "@ps-design-system/components/Select";
import { Text } from "@ps-design-system/components/Text";

import { useIntl } from "react-intl-compat";

const MIN_AGE_OPTIONS = Array.from({ length: 22 }, (_, age) => age)
  .slice(1)
  .sort((a, b) => b - a);

/** The "who's allowed" minimum-age select. */
const MinAgeField = () => {
  const intl = useIntl();

  return (
    <div className="tw-flex tw-flex-col tw-gap-16">
      <div className="tw-flex tw-flex-col tw-gap-8">
        <Text typeface="headline-4-b" element="h2" className="tw-m-0">
          <FormattedMessage
            id="hosting.space_rules.min_age_header"
            defaultMessage="Who's allowed in your space?"
          />
        </Text>
        <Text typeface="body-2" element="p" className="tw-m-0">
          <FormattedMessage
            id="hosting.space_rules.min_age_subheader"
            defaultMessage="Typically, only venues that serve alcohol have age requirements."
          />
        </Text>
      </div>

      <SelectField
        fullWidth
        name="minAge"
        testId="space-rules-form-min-age-select"
        renderContent={() => (
          <SelectContent>
            <SelectItem key="all-ages" value="0">
              {intl.formatMessage({
                id: "hosting.space_rules.min_age_all_ages",
                defaultMessage: "All ages",
              })}
            </SelectItem>
            {MIN_AGE_OPTIONS.map((age) => (
              <SelectItem key={age} value={String(age)}>
                {intl.formatMessage(
                  {
                    id: "hosting.space_rules.min_age_option",
                    defaultMessage: "Ages {age}+",
                  },
                  { age },
                )}
              </SelectItem>
            ))}
          </SelectContent>
        )}
      />
    </div>
  );
};

export { MinAgeField };
